// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Login_containerPrincipal__L-w0r","containerLogin":"Login_containerLogin__WFKhq"};